import { findBand, BAND_COLORS } from "../bands";

// SDAI / CDAI — Simplified / Clinical Disease Activity Index (rheumatoid arthritis).
// CDAI = SDAI without the CRP term. ⚠️ Verify clinically before relying on results.
const sdaiBands = [
    { label: "Remission", color: BAND_COLORS.remission, lte: 3.3 },
    { label: "Low", color: BAND_COLORS.low, lte: 11 },
    { label: "Moderate", color: BAND_COLORS.moderate, lte: 26 },
    { label: "High", color: BAND_COLORS.high },
];

const cdaiBands = [
    { label: "Remission", color: BAND_COLORS.remission, lte: 2.8 },
    { label: "Low", color: BAND_COLORS.low, lte: 10 },
    { label: "Moderate", color: BAND_COLORS.moderate, lte: 22 },
    { label: "High", color: BAND_COLORS.high },
];

export const sdaiCdai = {
    id: "sdai-cdai",
    name: "SDAI/CDAI",
    subtitle: "Simplified/clinical disease activity index (rheumatoid arthritis)",
    group: "Rheumatoid arthritis",
    status: "ready",
    options: [
        { key: "type", label: "Activity", choices: ["CDAI", "SDAI"], default: "CDAI" },
    ],
    fields: [
        { key: "tjc28", label: "Tender joint count (0–28)", unit: "joints", type: "number", min: 0, max: 28 },
        { key: "sjc28", label: "Swollen joint count (0–28)", unit: "joints", type: "number", min: 0, max: 28 },
        { key: "ptga", label: "Patient global disease activity (VAS)", unit: "cm", type: "number", min: 0, max: 10, step: 0.1 },
        { key: "phga", label: "Evaluator global disease activity (VAS)", unit: "cm", type: "number", min: 0, max: 10, step: 0.1 },
        {
            key: "crp",
            label: "CRP",
            unit: "mg/dL",
            type: "number",
            min: 0,
            max: 50,
            step: 0.1,
            showIf: (o) => o.type === "SDAI",
        },
    ],
    compute: (v, o) => {
        // Globals are 0–10 cm VAS and enter the sum directly (no scaling).
        const cdai = v.tjc28 + v.sjc28 + v.ptga + v.phga;
        return o.type === "SDAI" ? cdai + v.crp : cdai;
    },
    interpret: (score, o) => findBand(score, o.type === "SDAI" ? sdaiBands : cdaiBands),
    bands: (o) => (o.type === "SDAI" ? sdaiBands : cdaiBands),
    about:
        "The Simplified Disease Activity Index (SDAI) and the Clinical Disease Activity Index (CDAI) are two tools for the evaluation of disease activity in rheumatoid arthritis (RA), developed to give physicians and patients simple, comprehensible instruments. They were not developed to replace instruments such as the DAS28, but to provide options for different environments. SDAI is the linear sum of the 28 tender and swollen joint counts, patient and evaluator global disease activity (0–10 cm VAS each) and CRP in mg/dL; CDAI is the same sum without CRP.",
    references: [
        "Smolen JS, et al. A simplified disease activity index for rheumatoid arthritis. Rheumatology. 2003.",
        "Aletaha D, Smolen J. The Simplified Disease Activity Index (SDAI) and the Clinical Disease Activity Index (CDAI). Clin Exp Rheumatol. 2005.",
    ],
};
